import {
  List as MUIList,
  ListItem as MUIListItem,
  styled
} from '@mui/material';

export const BulletList = styled(MUIList)(({ theme }) => ({
  listStyleType: 'disc',
  marginLeft: theme.spacing(3),
  paddingBlock: 0
}));

export const BulletListItem = styled(MUIListItem)(({ theme }) => ({
  display: 'list-item',
  paddingInline: theme.spacing(1),
  paddingBlock: 0
}));
